module.exports = __webpack_public_path__ + "static/media/barcode.af47ce95.png";